import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_role_menu",
  ref: "rolesModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_roles_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  class: "d-flex align-items-center justify-content-between",
  style: {"margin-bottom":"16px"}
}
const _hoisted_10 = { style: {"padding-left":"24px","padding-top":"12px","padding-bottom":"4px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, " Phân quyền hệ thống: " + _toDisplayString(_ctx.data1.cTenNhomQuyen), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_checkbox, {
                size: _ctx.size,
                disabled: _ctx.selected?.nMaNhomQuyen == null,
                onChange: _ctx.handleCheckAll,
                modelValue: _ctx.checkAll,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkAll) = $event))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("b", null, "Chọn tất cả", -1)
                ]))]),
                _: 1
              }, 8, ["size", "disabled", "onChange", "modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.saveRoleMenu,
                size: _ctx.size
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Lưu", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "size"]),
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: _ctx.resetRoleMenu,
                size: _ctx.size
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Thiết lập lại", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "size"])
            ])
          ]),
          _createVNode(_component_el_tree, {
            data: _ctx.menuTree,
            "show-checkbox": "",
            "node-key": "nMaChucNang",
            props: _ctx.treeProp,
            "check-strictly": _ctx.checkStrictly,
            style: {"width":"100%","padding-top":"10px","max-height":"500px","overflow":"auto"},
            "render-content": _ctx.renderContent,
            ref: "treeRef",
            "default-expand-all": "",
            "highlight-current": true
          }, null, 8, ["data", "props", "check-strictly", "render-content"])
        ])
      ])
    ])
  ], 512))
}